module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_14.fbb84569.jpg";